import {
    DocumentNode,
    OperationVariables,
    TypedDocumentNode,
} from '@apollo/client';
import { useQuery as useActualQuery } from '@apollo/client/react';
import assert from '../util/assert';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Same as useQuery from @apollo/client with improved return types
 */
const useQuery = <
    TData = any,
    TVariables extends OperationVariables = OperationVariables,
>(
    query: DocumentNode | TypedDocumentNode<TData, TVariables>,
    options?: useActualQuery.Options<TData, TVariables>
) => {
    const { loading, data, error, ...rest } = useActualQuery<TData, TVariables>(
        query,
        options as any
    );

    if (error) {
        return { loading, data: data as TData | undefined, error, ...rest };
    }

    if (loading) {
        return { loading, data: data as TData | undefined, error, ...rest };
    }

    assert(data);

    return { loading, data: data as TData, error, ...rest };
};

export default useQuery;
